export default __webpack_public_path__ + "static/media/icon_stop_bullying.33dfea6b.svg";